<template>
  <div>
    <vx-card class="mb-1">
        <vs-row vs-type="flex" vs-justify="space-between" >          
          <vs-col vs-type="flex" vs-align="center" vs-w="8" vs-justify="center" >  
             <vs-row  class="mt-4"  vs-type="flex" vs-justify="space-between" vs-align="flex-start">     
                <vs-col vs-type="flex" vs-align="flex-start" vs-w="3">
                    <file-upload
                        class="btn btn-primary w-full mr-3 mt-4"                                                        
                        :post-action="getUrlPost"                                                                                   
                        :multiple="false"
                        :data="dadosUpload"      
                        
                        v-model="arquivosParaUpload"                             
                        ref="upload">
                        <i class="fa fa-plus"></i> Selecione o arquivo
                    </file-upload>
                </vs-col>                               
                <vs-col vs-type="flex" vs-w="9" v-if="arquivosParaUpload && arquivosParaUpload.length > 0">            
                  <vs-input class="w-full mr-2 mt-2" v-model="arquivosParaUpload[0].name" />                                                      
                </vs-col>   
              </vs-row>      
          </vs-col>
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">       
              <label class="vs-input--label">Banco</label>                     
              <v-select                                               
                  :options="CONSTANTES_BANCO_HOMOLOGADOS" 
                  v-model="filtro.instituicao.numero"    
                  :clearable="false"
                  :reduce="r => r.data"     
                  style="z-index: 10000 !important;"                                                                    
                  class="v-select w-full">
              </v-select>  
          </vs-col>             
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">            
            <vs-button class="ml-2 mt-5" color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-upload" v-if="!$refs.upload || !$refs.upload.active" :disabled="arquivosParaUpload.length === 0 || $refs.upload.uploaded " @click.prevent="enviarArquivoUpload()"></vs-button>      
          </vs-col>        
      </vs-row>    
      <vs-row vs-type="flex" vs-justify="center" v-if="arquivosParaUpload && arquivosParaUpload[0] && arquivosParaUpload[0].success">
            <vs-col vs-type="flex" vs-align="center" vs-w="12" vs-justify="center">              
              <div class="op-block w-full" style="white-space: pre-line">{{exibirMensagelResultadoUpload(arquivosParaUpload[0].response)}}</div>
            </vs-col>
      </vs-row>  
    </vx-card>
     
    <h6 class="ml-2 mt-2 mb-2 text-danger"> {{totalRegistros }} registros </h6>
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="25"
        :headerHeight="20"        
        rowSelection="multiple"
        rowMultiSelectWithClick="true"
        colResizeDefault="shift"        
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>

import { CONSTANTES_BANCO_HOMOLOGADOS } from '@/constantesComboBox.js'
import generico from '@/generico.js'
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import FileUpload from 'vue-upload-component'

export default {
  components: {
    AgGridVue,
    flatPickr,
    FileUpload
  },
  data() {
    return {
      filtro : { instituicao: {numero: '001'}},
      configuracaoGrid: { 
          gridApi: null, 
          gridOptions: {
            rowClassRules: {          
              'rag-pagamento-efetuado': function(params) { return params.data.mensagemResultado === 'Pagamento efetuado.Lançamento efetuado com sucesso.'; },
              'rag-pagamento-efetuado-previamente': function(params) { return params.data.mensagemResultado === 'Lançamento efetuado previamente.' },
              'rag-boleto-registrado':   function(params) { return params.data.mensagemResultado === 'Boleto registrado.'; },
            },
          },
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'N', field: 'numeroLancamento', width: 40, 
               cellRenderer: function(params) { 
                if (params.data.lancamento && params.data.lancamento.conta) {
                  return params.data.lancamento.conta.numeroConta + '/' + params.data.lancamento.numeroLancamento 
                } else {
                  return "Boleto:" + params.data.numeroBoleto;
                }
              }
            },                                                                                
            { headerName: 'CLIENTE', field: 'lancamento.conta.favorecido.nome'},                      
            { headerName: 'DT. PAGTO', field: 'dataPagamento', width: 50},            
            { headerName: 'DT. CREDITO', field: 'dataCreditoPagamento', width: 50},            
            { headerName: 'VALOR FATURA', field: 'lancamento.valor', width: 40, 
               cellRenderer: function(params) { 
                  if (params.data.lancamento && params.data.lancamento.valor) {
                    return generico.formatarMoedaReal(params.data.lancamento.valor) 
                  } else {
                    return "-";
                  }
               }
            },                                                                                            
            { headerName: 'VALOR PAGO', field: 'valorPago', width: 40, 
               cellRenderer: function(params) { 
                if (params.data.valorPago) {
                  return generico.formatarMoedaReal(params.data.valorPago) 
                } else {
                  return "-";
                }
               }
            },                                                                                                        
            { headerName: 'RESULTADO', field: 'mensagemResultado'},    
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },  
      numeroMesAtual: 0,
      acceptArquivos: ['.ret', '.crt'],
      isArquivoProcessado: false,
      arquivosParaUpload: [],
      extensoesArquivos: ['ret', 'crt'],
      resultadoUploadKML: null,
      dadosUpload: {
        'numeroBanco': null, 'nomeArquivo':null, 'idUsuario': String(this.$store.state.AppActiveUser.id)
      }
    }
  },  
  computed: {
    getUrlPost() {      
      return axios.defaults.baseURL  + "/uploadArquivoRetornoBB/processar2";
    },
  },
  created(){
        this.CONSTANTES_BANCO_HOMOLOGADOS = CONSTANTES_BANCO_HOMOLOGADOS;
  }, 
  methods: {
    enviarArquivoUpload(){     
        this.limparMsgErroUpload();                         
        this.dadosUpload.nomeArquivo = this.arquivosParaUpload[0].name;
        this.dadosUpload.numeroBanco = this.filtro.instituicao.numero;
        this.$refs.upload.update(this.arquivosParaUpload[0], { data: this.dadosUpload });
        this.$refs.upload.active = true;
        this.$vs.loading(); 
    },
    removeArquivoUpload() {
        this.isArquivoProcessado = false;
        this.$refs.upload.remove(this.arquivosParaUpload[0]);
        this.dadosUpload.nomeArquivo = "";
    },
    exibirMensagelResultadoUpload(resposta) {
        this.$vs.loading.close();                
        if (resposta) {            
            if (resposta.hasOwnProperty("Resultado")) {                                
                this.isArquivoProcessado = true;             
                this.$refs.upload.remove(this.arquivosParaUpload[0]);
                this.dadosUpload.nomeArquivo = "";                     
                this.totalRegistros = resposta.Resultado.quantidade;
                this.dadosDaGrid = resposta.Resultado.lista;
                if (resposta.Resultado.quantidade === 0) {                  
                     this.dadosDaGrid = [];
                      this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'warning',
                            text: 'Nenhum boleto encontrado.',
                        });
                }                                  
                return "Processamento realizado com sucesso.";    
            }
        }    

        return "Erro no processamento.";    
    },
    limparMsgErroUpload() {
      this.resultadoUploadKML = "";
    },    
    setMes(incrementar){
      
      if (incrementar) {
        this.numeroMesAtual = this.numeroMesAtual + 1;
      } else {
        this.numeroMesAtual = this.numeroMesAtual - 1;
      }

      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth() + this.numeroMesAtual, 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + this.numeroMesAtual, 0);

      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    },
    setMesAtual(){
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
      this.numeroMesAtual = 0;
    },
    limparFiltros() {
      this.filtro = {favorecido: {nome: null }, dataInicio:  null,dataFim : null};
    },    
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'Remessa.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    },
    getPrefixoArquivoRemessa() {
     return generico.getDataHoraYYYYMMDDHHMMSS();      
    },
    getNomeArquivoRemessa() {
      var currentDateTime = new Date();
      let nomeArquivo = "";
      
      if (this.filtro.instituicao.numero === "748") {        
        if (parseInt(currentDateTime.getMonth + 1) === 10) {
          nomeArquivo = "O"
        } else if (parseInt(currentDateTime.getMonth + 1) === 11) {
          nomeArquivo = "N";
        } else if (parseInt(currentDateTime.getMonth + 1) === 12) {
          nomeArquivo = "D";
        }

        nomeArquivo = nomeArquivo + generico.zeroPad(currentDateTime.getDate(), 2);
        nomeArquivo = this.dadosDaGrid[0].instituicao.conta + nomeArquivo; 
      } else {        
        nomeArquivo = generico.getDataHoraMMddhhmm();
      }
      
      return nomeArquivo;
    },
    gerarArquivo() {
      if (this.configuracaoGrid.gridApi && this.configuracaoGrid.gridApi.getSelectedRows() && this.configuracaoGrid.gridApi.getSelectedRows().length) {
          this.$vs.dialog({
            type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja gerar o arquivo de remessa de ' + this.configuracaoGrid.gridApi.getSelectedRows().length + ' lançamentos ?', acceptText: 'Sim', cancelText: 'Não', accept: this.gerarArquivoRequest
          });
      } else {
        this.$vs.notify({
            title: "Erro", iconPack: 'feather', icon: 'icon-alert', color: 'danger', text: 'Selecione pelo meno um item' });
      }
    },
    gerarArquivoRequest() {        
                
        var listIds = null;

        var selectedRows = this.configuracaoGrid.gridApi.getSelectedRows();
        selectedRows.forEach(function(selectedRow) {            
            if (listIds === null) {
                listIds = new String();
                listIds = listIds + selectedRow.id;
            } else {
                listIds = listIds + "," + selectedRow.id;
            }
        });       

        this.$vs.loading();
        const params = new URLSearchParams();                
        params.append('idUsuario', String(this.$store.state.AppActiveUser.id));        
        params.append('listaIds', listIds);  
        params.append('sequencialRemessa', this.getPrefixoArquivoRemessa());  
        let nomeArquivo = this.getNomeArquivoRemessa();

        if (this.filtro.instituicao.numero === "748") {
          nomeArquivo = nomeArquivo + ".CRM";
        } else {
          nomeArquivo = nomeArquivo + ".rem";
        }
        params.append('nomeArquivoDownload', nomeArquivo);                       
                
        axios.post("/Lancamento/GerarArquivoRemessa", params, {              
                timeout: 600000, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true,  responseType: 'arraybuffer' } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                  this.$router.push({ path: '/login' });  // Efetuar logoff
            } else {                                                                
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', nomeArquivo);
                document.body.appendChild(fileLink);
                fileLink.click();                
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            this.$vs.loading.close();
        }) 
    },
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   

    if (this.$store.getters.filtroItemContaFuturo) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroItemContaFuturo));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    }   
  },
  beforeDestroy() {    
    //this.$store.dispatch('setarFiltro', {nomeTela: 'itemContaFuturo' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 310px);
  }
  
</style>

<style lang="scss">
  
  .rag-pagamento-efetuado {
    background-color: rgb(14, 207, 8) !important;
    color: rgb(247, 244, 244)  !important;
  }

  .rag-pagamento-efetuado-previamente {
    background-color: #FFFFFF !important;
    color: rgb(0, 0, 0)  !important;
  }

  .rag-boleto-registrado {
     color: rgb(236, 235, 235) !important;
     background-color: #004dea !important;   
  }
</style>
